module.exports = __webpack_public_path__ + "img/Rectangle 131.4d0d3ad7.png";